/* eslint-disable */
import "../../components/component-questionnaire/B4FDate/react-datepicker.css";

import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  getPart, getTranslationByPart,
  updateFundPart,
  updatePartTextTranslation,
} from "../../utils/store/actions/funds.actions";
import {
  Button,
  Card,
  CardContent,
} from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { B4FText } from "../../components/component-questionnaire/B4FFields/B4FText";
import { getEnums } from "../../utils/store/actions/survey.action";
import React from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 800,
    },
  },
};

const styles = (theme: Theme) =>
  createStyles({
    fundCards: {
      borderRadius: "12px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    chip: {
      margin: 2,
    },
    savePart: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "-webkit-fill-available",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
    },
  });
class PartTranslation extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      part: {},
      translation: this.props.getTranslationByPart(this.props.Funds.part.id),
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  fundPersonId = this.urlParams.get("id");

  async componentDidMount() {
    await this.setState({
      part: this.props.Funds.part,
      translation: this.props.translation,
    });
  }


  handleSave = (e: any) => {
    this.props.updateFundPart(this.state.part, this.fundPersonId).then(() => {
      this.props.updatePartTextTranslation(this.state.part.id, this.state.translation).then(() => {
        this.props.getPart(this.fundPersonId, this.state.part.id).then(() => {
          this.props.getTranslationByPart(this.state.part.id);
        });
      });
    });
  };

  render() {
    const {classes, t} = this.props;
    return (
      <div>
        <div style={{margin: "1%", fontWeight: "bolder"}}>
          {t("ONLINE_APPLICATION_INTRODUCTION")[0].toUpperCase() +
            t("ONLINE_APPLICATION_INTRODUCTION").slice(1).toLowerCase()}
        </div>
        <Card className={classes.card}>
          <CardContent className={classes.fundCards}>
            <B4FText
              label="PART_TEXT_FR"
              value={this.props.Funds.translation.fr}
              onBlur={console.log}
              onChange={(e: any) => {
                this.setState({
                  translation: {
                    ...this.state.translation,
                    fr: e.value,
                  },
                });
              }}
              id="partTextFr"
              key="partTextFr"
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
            <B4FText
              label="PART_TEXT_EN"
              value={this.props.Funds.translation.en}
              onBlur={console.log}
              onChange={(e: any) => {
                this.setState({
                  translation: {
                    ...this.state.translation,
                    en: e.value,
                  },
                });
              }}
              id="partTextEn"
              key="partTextEn"
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
            <B4FText
              label="PART_TEXT_ES"
              value={this.props.Funds.translation.es}
              onBlur={console.log}
              onChange={(e: any) => {
                this.setState({
                  translation: {
                    ...this.state.translation,
                    es: e.value,
                  },
                });
              }}
              id="partTextEs"
              key="partTextEs"
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
            <B4FText
              label="PART_TEXT_IT"
              value={this.props.Funds.translation.it}
              onBlur={console.log}
              onChange={(e: any) => {
                this.setState({
                  translation: {
                    ...this.state.translation,
                    it: e.value,
                  },
                });
              }}
              id="partTextIt"
              key="partTextIt"
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
          </CardContent>
          <Button
            variant="contained"
            className={classes.savePart}
            onClick={(e) => this.handleSave(e)}
          >
            {t("SAVE")}
          </Button>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getPart,
  updateFundPart,
  getTranslationByPart,
  updatePartTextTranslation,
  getEnums,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartTranslation)));
